import { render, staticRenderFns } from "./income.vue?vue&type=template&id=24bc4e59"
import script from "./income.vue?vue&type=script&lang=js"
export * from "./income.vue?vue&type=script&lang=js"
import style0 from "./income.vue?vue&type=style&index=0&id=24bc4e59&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports